import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ScheduledApplicationsRequestService } from './scheduled-applications-request-service';
import { ScheduledApplicationsEffects } from './scheduled-applications.effects';
import { scheduledApplicationsReducer } from './scheduled-applications.reducer';

export const provideScheduledApplicationsStore = () => [
  provideState('scheduledApplications', scheduledApplicationsReducer),
  provideEffects([ScheduledApplicationsEffects]),
  ScheduledApplicationsRequestService,
];
